import React, { useCallback } from 'react'

import {
  Button,
  Icon,
  Refresh,
  ClockDefault,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf, func } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import { IMAGE_RESTORE_STATUS } from './constants'

const { IDLE, PENDING } = IMAGE_RESTORE_STATUS
const KEY_PREFIX = 'profile.my_models.image_restore'

// Collapsed top-right control shown after the banner is dismissed. For `idle`
// it re-opens the banner; for `pending` it mirrors the disabled state.
function RestoreControl({ status, onExpand }) {
  const translate = useCallback(
    (key) => I18n.t(`${KEY_PREFIX}.${key}`, { ns: 'rails' }),
    []
  )

  const isPending = status === PENDING

  return (
    <div className="image-restore-control">
      <Button
        type="ghost-primary"
        actionType="button"
        size="small"
        disabled={isPending}
        onClick={isPending ? undefined : onExpand}
        icon={<Icon svgComponent={isPending ? ClockDefault : Refresh} size="small" notSpaced />}
      >
        {translate(isPending ? 'button_requested' : 'button_restore')}
      </Button>
    </div>
  )
}

RestoreControl.propTypes = {
  status: oneOf([IDLE, PENDING]).isRequired,
  onExpand: func.isRequired,
}

export default RestoreControl
